<template>
  <v-row justify="center">
    <v-col cols="12" md="7" xl="5" style="padding: 0px; padding-top: 2vh">
      <v-row justify-center class="ma-0 pa-0">
        <v-icon color="primary" x-large class="d-inline-block mx-auto">
          <slot name="icon" />
        </v-icon>
      </v-row>
      <h1 class="primary--text my-5 text-center font-weight-regular app-header-with-subtitle__header">
        <slot />
      </h1>
      <p class="black--text font-weight-light text-center app-header-with-subtitle__subtitle">
        <slot name="subtitle" />
      </p>
      <hr class="app-header-with-subtitle__separator mx-auto my-5 primary" role="separator" aria-orientation="horizontal">
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AppHeaderWithSubtitle'
}
</script>

<style>
  .app-header-with-subtitle__header {
    font-size: 2.5rem;
    line-height: 1;
  }

  .app-header-with-subtitle__subtitle {
    font-size: 1.2rem
  }

  .app-header-with-subtitle__separator {
    width: 150px;
  }
</style>